import cn from 'classnames';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import { useSearch } from 'src/modules/newCars/hooks/useSearch';
import { BreadCrumbs, Button, ButtonVariants, Input, Typography } from 'ui';
import Search from 'ui/components/newIcons/Search';
import { Color, TypeScales } from 'ui/primitives';
import s from './CategoryHero.module.scss';

export const CategoryHero = ({ strapiContent, label, brandsList, slug }) => {
  const { value, setValue, suggestions, loading } = useSearch(brandsList);
  const router = useRouter();
  function handleOnChange(e) {
    setValue(e.target.value);
  }
  function handleClick(link) {
    router?.push(link);
  }
  function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  const makeHeadingWithFilter = () => {
    let headingWithFilters = '';
    slug.map((filter, index) => {
      if (filter.includes('seater')) {
        headingWithFilters += slug[index] + ' ';
      } else if (filter.includes('lakhs')) {
        headingWithFilters += 'cars under ' + slug[index];
      } else {
        headingWithFilters += slug[index].split('-')[0] + ' ';
      }
    });
    if (headingWithFilters.includes('cars'))
      return titleCase((headingWithFilters += ' in India'));
    else return titleCase((headingWithFilters += ' cars in India'));
  };

  return (
    <div className={s.root}>
      <figure className={s.figure}>
        <Image
          priority
          src={strapiContent?.heroImage?.data?.attributes?.url}
          alt=""
          layout="fill"
          objectFit="cover"
        />
      </figure>
      <div className={s.overlay} />
      <div className={s.content}>
        <Typography
          className={s.heading}
          label={makeHeadingWithFilter()}
          color={Color.grey_white}
          renderAs="H1"
          variant={TypeScales.h1}
        />
        <div className={cn(s.search_bar, 'cmn_only_desktop')}>
          <div className={s.input_with_btn}>
            <div className={s.input}>
              <Input
                leftIcon={<Search primaryColor={Color.text_subheading} />}
                placeholder="Search cars"
                onChange={handleOnChange}
                className={s.input_bar}
              />
              {suggestions?.length && (
                <div className={s.suggestions}>
                  {suggestions
                    ?.map?.((obj) => (
                      <a
                        key={obj?.title}
                        className={cn(s.suggestion_btn, 'cmn_touchable_area')}
                        href={obj?.link}
                      >
                        <Search
                          height={20}
                          width={20}
                          primaryColor={Color.text_subheading}
                        />
                        {obj.title}
                      </a>
                    ))
                    ?.filter((obj, idx) => idx < 8)}
                </div>
              )}
            </div>
            <div className={s.btn}>
              <Button
                label="Search Cars"
                variant={ButtonVariants.PrimaryOutline}
              />
            </div>
          </div>
          <div className={s.bread_crumb}>
            <BreadCrumbs
              theme="light"
              data={[
                { name: 'Home', url: '/', type: 'internal', id: 1 },
                { name: 'New cars', url: '/new-cars', type: 'internal', id: 2 },
                {
                  name: slug[0]?.replace(/-/g, ' '),
                  url: `/new-cars/${slug[0]}`,
                  type: 'internal',
                  id: 3,
                },
                ...(slug[1]
                  ? [
                      {
                        name: slug[1]?.replace(/-/g, ' '),
                        url: `/new-cars/${slug[0]}/${slug[1]}`,
                        type: 'internal',
                        id: 4,
                      },
                    ]
                  : []),
                ...(slug[2]
                  ? [
                      {
                        name: slug[2]?.replace(/-/g, ' '),
                        url: `/new-cars/${slug[0]}/${slug[1]}/${slug[2]}`,
                        type: 'internal',
                        id: 5,
                      },
                    ]
                  : []),
                ...(slug[3]
                  ? [
                      {
                        name: slug[3]?.replace(/-/g, ' '),
                        url: `/new-cars/${slug[0]}/${slug[1]}/${slug[2]}/${slug[3]}`,
                        type: 'internal',
                        id: 6,
                      },
                    ]
                  : []),
                ...(slug[4]
                  ? [
                      {
                        name: slug[4]?.replace(/-/g, ' '),
                        url: `/new-cars/${slug[0]}/${slug[1]}/${slug[2]}/${slug[3]}/${slug[4]}`,
                        type: 'internal',
                        id: 7,
                      },
                    ]
                  : []),
                ...(slug[5]
                  ? [
                      {
                        name: slug[5]?.replace(/-/g, ' '),
                        url: `/new-cars/${slug[0]}/${slug[1]}/${slug[2]}/${slug[3]}/${slug[4]}/${slug[5]}`,
                        type: 'internal',
                        id: 8,
                      },
                    ]
                  : []),
              ]}
            />
          </div>
        </div>
        <div className={cn(s.mobile_search, 'cmn_only_mobile')}>
          <div className={s.input_bar}>
            <Input
              leftIcon={<Search primaryColor={Color.text_subheading} />}
              placeholder="Search cars"
              onChange={handleOnChange}
            />
          </div>

          {suggestions?.length && (
            <div className={s.suggestions}>
              {suggestions
                ?.map?.((obj) => (
                  <button
                    type="button"
                    key={obj?.title}
                    className={cn(s.suggestion_btn, 'cmn_touchable_area')}
                    onClick={() => handleClick(obj?.link)}
                  >
                    <Search
                      height={20}
                      width={20}
                      primaryColor={Color.text_subheading}
                    />{' '}
                    {obj.title}
                  </button>
                ))
                ?.filter((obj, idx) => idx < 8)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
